// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/external_tickets/v1/external_tickets.proto" (package "c1.api.external_tickets.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { TicketSchema } from "../../../connector/v2/ticket";
/**
 * @generated from protobuf message c1.api.external_tickets.v1.DeleteExternalTicketProvisionerConfigRequest
 */
export interface DeleteExternalTicketProvisionerConfigRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string id = 3
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.DeleteExternalTicketProvisionerConfigResponse
 */
export interface DeleteExternalTicketProvisionerConfigResponse {
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.UpdateExternalTicketProvisionerConfigRequest
 */
export interface UpdateExternalTicketProvisionerConfigRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string id = 3
     */
    id: string;
    /**
     * @generated from protobuf field: string ticket_title_template = 4
     */
    ticketTitleTemplate: string;
    /**
     * @generated from protobuf field: string ticket_body_template = 5
     */
    ticketBodyTemplate: string;
    /**
     * @generated from protobuf field: c1.connector.v2.TicketSchema ticket_schema = 6
     */
    ticketSchema?: TicketSchema;
    /**
     * @generated from protobuf field: string error_status = 7
     */
    errorStatus: string;
    /**
     * @generated from protobuf field: string success_status = 8
     */
    successStatus: string;
    /**
     * @generated from protobuf field: string display_name = 9
     */
    displayName: string;
    /**
     * @generated from protobuf field: string label = 10
     */
    label: string;
    /**
     * @generated from protobuf field: string ticket_type = 11
     */
    ticketType: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.UpdateExternalTicketProvisionerConfigResponse
 */
export interface UpdateExternalTicketProvisionerConfigResponse {
    /**
     * @generated from protobuf field: c1.api.external_tickets.v1.ExternalTicketProvisionerConfig config = 1
     */
    config?: ExternalTicketProvisionerConfig;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.GetConnectorExternalTicketProvisionerRequest
 */
export interface GetConnectorExternalTicketProvisionerRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.GetConnectorExternalTicketProvisionerResponse
 */
export interface GetConnectorExternalTicketProvisionerResponse {
    /**
     * @generated from protobuf field: c1.api.external_tickets.v1.ConnectorExternalTicketProvisioner connector = 1
     */
    connector?: ConnectorExternalTicketProvisioner;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ProcessExternalTicketForBulkActionRequest
 */
export interface ProcessExternalTicketForBulkActionRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string id = 3
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ProcessExternalTicketForBulkActionResponse
 */
export interface ProcessExternalTicketForBulkActionResponse {
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ListConnectorExternalTicketProvisionerRequest
 */
export interface ListConnectorExternalTicketProvisionerRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: bool exclude_no_ticket_schemas = 3
     */
    excludeNoTicketSchemas: boolean;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ListConnectorExternalTicketProvisionerResponse
 */
export interface ListConnectorExternalTicketProvisionerResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_tickets.v1.ConnectorExternalTicketProvisioner list = 1
     */
    list: ConnectorExternalTicketProvisioner[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.CreateExternalTicketProvisionerConfigRequest
 */
export interface CreateExternalTicketProvisionerConfigRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.CreateExternalTicketProvisionerConfigResponse
 */
export interface CreateExternalTicketProvisionerConfigResponse {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ListExternalTicketProvisionerConfigRequest
 */
export interface ListExternalTicketProvisionerConfigRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 5
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.external_tickets.v1.ExternalTicketProvisionerConfigRef refs = 6
     */
    refs: ExternalTicketProvisionerConfigRef[];
    /**
     * @generated from protobuf field: bool exclude_empty_ticket_schema = 7
     */
    excludeEmptyTicketSchema: boolean;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ListExternalTicketProvisionerConfigResponse
 */
export interface ListExternalTicketProvisionerConfigResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_tickets.v1.ExternalTicketProvisionerConfig list = 1
     */
    list: ExternalTicketProvisionerConfig[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.GetExternalTicketProvisionerConfigRequest
 */
export interface GetExternalTicketProvisionerConfigRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string id = 3
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.GetExternalTicketProvisionerConfigResponse
 */
export interface GetExternalTicketProvisionerConfigResponse {
    /**
     * @generated from protobuf field: c1.api.external_tickets.v1.ExternalTicketProvisionerConfig config = 1
     */
    config?: ExternalTicketProvisionerConfig;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ConnectorExternalTicketProvisioner
 */
export interface ConnectorExternalTicketProvisioner {
    /**
     * @generated from protobuf field: string tenant_id = 1
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3
     */
    connectorId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketSchema ticket_schemas = 7
     */
    ticketSchemas: TicketSchema[];
    /**
     * @generated from protobuf field: string display_name = 8
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ExternalTicketProvisionerConfig
 */
export interface ExternalTicketProvisionerConfig {
    /**
     * @generated from protobuf field: string tenant_id = 1
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string id = 4
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string ticket_title_template = 8
     */
    ticketTitleTemplate: string;
    /**
     * @generated from protobuf field: string ticket_body_template = 9
     */
    ticketBodyTemplate: string;
    /**
     * @generated from protobuf field: c1.connector.v2.TicketSchema ticket_schema = 10
     */
    ticketSchema?: TicketSchema;
    /**
     * @generated from protobuf field: string error_status = 11
     */
    errorStatus: string;
    /**
     * @generated from protobuf field: string success_status = 12
     */
    successStatus: string;
    /**
     * @generated from protobuf field: string display_name = 13
     */
    displayName: string;
    /**
     * @generated from protobuf field: string label = 14
     */
    label: string;
    /**
     * @generated from protobuf field: string ticket_type = 15
     */
    ticketType: string;
    /**
     * @generated from protobuf field: bool out_of_date = 16
     */
    outOfDate: boolean;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ExternalTicketProvisionerConfigRef
 */
export interface ExternalTicketProvisionerConfigRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ExternalTicketRef
 */
export interface ExternalTicketRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string external_ticket_provisioner_config_id = 2
     */
    externalTicketProvisionerConfigId: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.ExternalTicket
 */
export interface ExternalTicket {
    /**
     * @generated from protobuf field: string tenant_id = 1
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string external_ticket_provisioner_config_id = 2
     */
    externalTicketProvisionerConfigId: string;
    /**
     * @generated from protobuf field: string id = 3
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string external_ticket_id = 7
     */
    externalTicketId: string;
    /**
     * @generated from protobuf field: string external_ticket_status = 8
     */
    externalTicketStatus: string;
    /**
     * @generated from protobuf field: string external_ticket_url = 9
     */
    externalTicketUrl: string;
    /**
     * @generated from protobuf field: c1.api.external_tickets.v1.ExternalTicketState state = 11
     */
    state: ExternalTicketState;
    /**
     * @generated from protobuf field: string app_id = 12
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 13
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string internal_ticket_id = 14
     */
    internalTicketId: string;
    /**
     * @generated from protobuf field: int32 attempts = 15
     */
    attempts: number;
    /**
     * @generated from protobuf field: string last_error = 16
     */
    lastError: string;
    /**
     * @generated from protobuf field: string external_ticket_status_display_name = 17
     */
    externalTicketStatusDisplayName: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.GetExternalTicketRequest
 */
export interface GetExternalTicketRequest {
    /**
     * @generated from protobuf field: string provisioner_config_id = 1
     */
    provisionerConfigId: string;
    /**
     * @generated from protobuf field: string external_ticket_id = 4
     */
    externalTicketId: string;
}
/**
 * @generated from protobuf message c1.api.external_tickets.v1.GetExternalTicketResponse
 */
export interface GetExternalTicketResponse {
    /**
     * @generated from protobuf field: c1.api.external_tickets.v1.ExternalTicket external_ticket = 1
     */
    externalTicket?: ExternalTicket;
}
/**
 * @generated from protobuf enum c1.api.external_tickets.v1.ExternalTicketState
 */
export enum ExternalTicketState {
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_CREATING = 2;
     */
    CREATING = 2,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_FETCHING = 3;
     */
    FETCHING = 3,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_ERROR = 4;
     */
    ERROR = 4,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_PROCESSING = 5;
     */
    PROCESSING = 5,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_RESOLVED = 6;
     */
    RESOLVED = 6,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_FATAL_ERROR = 7;
     */
    FATAL_ERROR = 7,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_SKIPPED = 8;
     */
    SKIPPED = 8,
    /**
     * @generated from protobuf enum value: EXTERNAL_TICKET_STATE_CANCELLED = 9;
     */
    CANCELLED = 9
}
// @generated message type with reflection information, may provide speed optimized methods
class DeleteExternalTicketProvisionerConfigRequest$Type extends MessageType<DeleteExternalTicketProvisionerConfigRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.DeleteExternalTicketProvisionerConfigRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DeleteExternalTicketProvisionerConfigRequest>): DeleteExternalTicketProvisionerConfigRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteExternalTicketProvisionerConfigRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteExternalTicketProvisionerConfigRequest): DeleteExternalTicketProvisionerConfigRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteExternalTicketProvisionerConfigRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.DeleteExternalTicketProvisionerConfigRequest
 */
export const DeleteExternalTicketProvisionerConfigRequest = new DeleteExternalTicketProvisionerConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteExternalTicketProvisionerConfigResponse$Type extends MessageType<DeleteExternalTicketProvisionerConfigResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.DeleteExternalTicketProvisionerConfigResponse", []);
    }
    create(value?: PartialMessage<DeleteExternalTicketProvisionerConfigResponse>): DeleteExternalTicketProvisionerConfigResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteExternalTicketProvisionerConfigResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteExternalTicketProvisionerConfigResponse): DeleteExternalTicketProvisionerConfigResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteExternalTicketProvisionerConfigResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.DeleteExternalTicketProvisionerConfigResponse
 */
export const DeleteExternalTicketProvisionerConfigResponse = new DeleteExternalTicketProvisionerConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExternalTicketProvisionerConfigRequest$Type extends MessageType<UpdateExternalTicketProvisionerConfigRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.UpdateExternalTicketProvisionerConfigRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "ticket_title_template", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "ticket_body_template", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "ticket_schema", kind: "message", T: () => TicketSchema },
            { no: 7, name: "error_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "success_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "ticket_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateExternalTicketProvisionerConfigRequest>): UpdateExternalTicketProvisionerConfigRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.id = "";
        message.ticketTitleTemplate = "";
        message.ticketBodyTemplate = "";
        message.errorStatus = "";
        message.successStatus = "";
        message.displayName = "";
        message.label = "";
        message.ticketType = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateExternalTicketProvisionerConfigRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateExternalTicketProvisionerConfigRequest): UpdateExternalTicketProvisionerConfigRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                case /* string ticket_title_template */ 4:
                    message.ticketTitleTemplate = reader.string();
                    break;
                case /* string ticket_body_template */ 5:
                    message.ticketBodyTemplate = reader.string();
                    break;
                case /* c1.connector.v2.TicketSchema ticket_schema */ 6:
                    message.ticketSchema = TicketSchema.internalBinaryRead(reader, reader.uint32(), options, message.ticketSchema);
                    break;
                case /* string error_status */ 7:
                    message.errorStatus = reader.string();
                    break;
                case /* string success_status */ 8:
                    message.successStatus = reader.string();
                    break;
                case /* string display_name */ 9:
                    message.displayName = reader.string();
                    break;
                case /* string label */ 10:
                    message.label = reader.string();
                    break;
                case /* string ticket_type */ 11:
                    message.ticketType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateExternalTicketProvisionerConfigRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        /* string ticket_title_template = 4; */
        if (message.ticketTitleTemplate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.ticketTitleTemplate);
        /* string ticket_body_template = 5; */
        if (message.ticketBodyTemplate !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.ticketBodyTemplate);
        /* c1.connector.v2.TicketSchema ticket_schema = 6; */
        if (message.ticketSchema)
            TicketSchema.internalBinaryWrite(message.ticketSchema, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string error_status = 7; */
        if (message.errorStatus !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.errorStatus);
        /* string success_status = 8; */
        if (message.successStatus !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.successStatus);
        /* string display_name = 9; */
        if (message.displayName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.displayName);
        /* string label = 10; */
        if (message.label !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.label);
        /* string ticket_type = 11; */
        if (message.ticketType !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.ticketType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.UpdateExternalTicketProvisionerConfigRequest
 */
export const UpdateExternalTicketProvisionerConfigRequest = new UpdateExternalTicketProvisionerConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExternalTicketProvisionerConfigResponse$Type extends MessageType<UpdateExternalTicketProvisionerConfigResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.UpdateExternalTicketProvisionerConfigResponse", [
            { no: 1, name: "config", kind: "message", T: () => ExternalTicketProvisionerConfig }
        ]);
    }
    create(value?: PartialMessage<UpdateExternalTicketProvisionerConfigResponse>): UpdateExternalTicketProvisionerConfigResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateExternalTicketProvisionerConfigResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateExternalTicketProvisionerConfigResponse): UpdateExternalTicketProvisionerConfigResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.external_tickets.v1.ExternalTicketProvisionerConfig config */ 1:
                    message.config = ExternalTicketProvisionerConfig.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateExternalTicketProvisionerConfigResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.external_tickets.v1.ExternalTicketProvisionerConfig config = 1; */
        if (message.config)
            ExternalTicketProvisionerConfig.internalBinaryWrite(message.config, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.UpdateExternalTicketProvisionerConfigResponse
 */
export const UpdateExternalTicketProvisionerConfigResponse = new UpdateExternalTicketProvisionerConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorExternalTicketProvisionerRequest$Type extends MessageType<GetConnectorExternalTicketProvisionerRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.GetConnectorExternalTicketProvisionerRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetConnectorExternalTicketProvisionerRequest>): GetConnectorExternalTicketProvisionerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<GetConnectorExternalTicketProvisionerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetConnectorExternalTicketProvisionerRequest): GetConnectorExternalTicketProvisionerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetConnectorExternalTicketProvisionerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.GetConnectorExternalTicketProvisionerRequest
 */
export const GetConnectorExternalTicketProvisionerRequest = new GetConnectorExternalTicketProvisionerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorExternalTicketProvisionerResponse$Type extends MessageType<GetConnectorExternalTicketProvisionerResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.GetConnectorExternalTicketProvisionerResponse", [
            { no: 1, name: "connector", kind: "message", T: () => ConnectorExternalTicketProvisioner }
        ]);
    }
    create(value?: PartialMessage<GetConnectorExternalTicketProvisionerResponse>): GetConnectorExternalTicketProvisionerResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetConnectorExternalTicketProvisionerResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetConnectorExternalTicketProvisionerResponse): GetConnectorExternalTicketProvisionerResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.external_tickets.v1.ConnectorExternalTicketProvisioner connector */ 1:
                    message.connector = ConnectorExternalTicketProvisioner.internalBinaryRead(reader, reader.uint32(), options, message.connector);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetConnectorExternalTicketProvisionerResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.external_tickets.v1.ConnectorExternalTicketProvisioner connector = 1; */
        if (message.connector)
            ConnectorExternalTicketProvisioner.internalBinaryWrite(message.connector, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.GetConnectorExternalTicketProvisionerResponse
 */
export const GetConnectorExternalTicketProvisionerResponse = new GetConnectorExternalTicketProvisionerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProcessExternalTicketForBulkActionRequest$Type extends MessageType<ProcessExternalTicketForBulkActionRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.ProcessExternalTicketForBulkActionRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ProcessExternalTicketForBulkActionRequest>): ProcessExternalTicketForBulkActionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ProcessExternalTicketForBulkActionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProcessExternalTicketForBulkActionRequest): ProcessExternalTicketForBulkActionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProcessExternalTicketForBulkActionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ProcessExternalTicketForBulkActionRequest
 */
export const ProcessExternalTicketForBulkActionRequest = new ProcessExternalTicketForBulkActionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProcessExternalTicketForBulkActionResponse$Type extends MessageType<ProcessExternalTicketForBulkActionResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.ProcessExternalTicketForBulkActionResponse", []);
    }
    create(value?: PartialMessage<ProcessExternalTicketForBulkActionResponse>): ProcessExternalTicketForBulkActionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ProcessExternalTicketForBulkActionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProcessExternalTicketForBulkActionResponse): ProcessExternalTicketForBulkActionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProcessExternalTicketForBulkActionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ProcessExternalTicketForBulkActionResponse
 */
export const ProcessExternalTicketForBulkActionResponse = new ProcessExternalTicketForBulkActionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListConnectorExternalTicketProvisionerRequest$Type extends MessageType<ListConnectorExternalTicketProvisionerRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.ListConnectorExternalTicketProvisionerRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "exclude_no_ticket_schemas", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ListConnectorExternalTicketProvisionerRequest>): ListConnectorExternalTicketProvisionerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.excludeNoTicketSchemas = false;
        if (value !== undefined)
            reflectionMergePartial<ListConnectorExternalTicketProvisionerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListConnectorExternalTicketProvisionerRequest): ListConnectorExternalTicketProvisionerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* bool exclude_no_ticket_schemas */ 3:
                    message.excludeNoTicketSchemas = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListConnectorExternalTicketProvisionerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* bool exclude_no_ticket_schemas = 3; */
        if (message.excludeNoTicketSchemas !== false)
            writer.tag(3, WireType.Varint).bool(message.excludeNoTicketSchemas);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ListConnectorExternalTicketProvisionerRequest
 */
export const ListConnectorExternalTicketProvisionerRequest = new ListConnectorExternalTicketProvisionerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListConnectorExternalTicketProvisionerResponse$Type extends MessageType<ListConnectorExternalTicketProvisionerResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.ListConnectorExternalTicketProvisionerResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorExternalTicketProvisioner },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListConnectorExternalTicketProvisionerResponse>): ListConnectorExternalTicketProvisionerResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListConnectorExternalTicketProvisionerResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListConnectorExternalTicketProvisionerResponse): ListConnectorExternalTicketProvisionerResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.external_tickets.v1.ConnectorExternalTicketProvisioner list */ 1:
                    message.list.push(ConnectorExternalTicketProvisioner.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListConnectorExternalTicketProvisionerResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.external_tickets.v1.ConnectorExternalTicketProvisioner list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ConnectorExternalTicketProvisioner.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ListConnectorExternalTicketProvisionerResponse
 */
export const ListConnectorExternalTicketProvisionerResponse = new ListConnectorExternalTicketProvisionerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExternalTicketProvisionerConfigRequest$Type extends MessageType<CreateExternalTicketProvisionerConfigRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.CreateExternalTicketProvisionerConfigRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateExternalTicketProvisionerConfigRequest>): CreateExternalTicketProvisionerConfigRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<CreateExternalTicketProvisionerConfigRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateExternalTicketProvisionerConfigRequest): CreateExternalTicketProvisionerConfigRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateExternalTicketProvisionerConfigRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.CreateExternalTicketProvisionerConfigRequest
 */
export const CreateExternalTicketProvisionerConfigRequest = new CreateExternalTicketProvisionerConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExternalTicketProvisionerConfigResponse$Type extends MessageType<CreateExternalTicketProvisionerConfigResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.CreateExternalTicketProvisionerConfigResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<CreateExternalTicketProvisionerConfigResponse>): CreateExternalTicketProvisionerConfigResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<CreateExternalTicketProvisionerConfigResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateExternalTicketProvisionerConfigResponse): CreateExternalTicketProvisionerConfigResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 3:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateExternalTicketProvisionerConfigResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 3; */
        if (message.connectorId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.CreateExternalTicketProvisionerConfigResponse
 */
export const CreateExternalTicketProvisionerConfigResponse = new CreateExternalTicketProvisionerConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExternalTicketProvisionerConfigRequest$Type extends MessageType<ListExternalTicketProvisionerConfigRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.ListExternalTicketProvisionerConfigRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExternalTicketProvisionerConfigRef },
            { no: 7, name: "exclude_empty_ticket_schema", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ListExternalTicketProvisionerConfigRequest>): ListExternalTicketProvisionerConfigRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.refs = [];
        message.excludeEmptyTicketSchema = false;
        if (value !== undefined)
            reflectionMergePartial<ListExternalTicketProvisionerConfigRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExternalTicketProvisionerConfigRequest): ListExternalTicketProvisionerConfigRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 5:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.external_tickets.v1.ExternalTicketProvisionerConfigRef refs */ 6:
                    message.refs.push(ExternalTicketProvisionerConfigRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool exclude_empty_ticket_schema */ 7:
                    message.excludeEmptyTicketSchema = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExternalTicketProvisionerConfigRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 5; */
        if (message.query !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.external_tickets.v1.ExternalTicketProvisionerConfigRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            ExternalTicketProvisionerConfigRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool exclude_empty_ticket_schema = 7; */
        if (message.excludeEmptyTicketSchema !== false)
            writer.tag(7, WireType.Varint).bool(message.excludeEmptyTicketSchema);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ListExternalTicketProvisionerConfigRequest
 */
export const ListExternalTicketProvisionerConfigRequest = new ListExternalTicketProvisionerConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExternalTicketProvisionerConfigResponse$Type extends MessageType<ListExternalTicketProvisionerConfigResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.ListExternalTicketProvisionerConfigResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExternalTicketProvisionerConfig },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListExternalTicketProvisionerConfigResponse>): ListExternalTicketProvisionerConfigResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListExternalTicketProvisionerConfigResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExternalTicketProvisionerConfigResponse): ListExternalTicketProvisionerConfigResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.external_tickets.v1.ExternalTicketProvisionerConfig list */ 1:
                    message.list.push(ExternalTicketProvisionerConfig.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExternalTicketProvisionerConfigResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.external_tickets.v1.ExternalTicketProvisionerConfig list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ExternalTicketProvisionerConfig.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ListExternalTicketProvisionerConfigResponse
 */
export const ListExternalTicketProvisionerConfigResponse = new ListExternalTicketProvisionerConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExternalTicketProvisionerConfigRequest$Type extends MessageType<GetExternalTicketProvisionerConfigRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.GetExternalTicketProvisionerConfigRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetExternalTicketProvisionerConfigRequest>): GetExternalTicketProvisionerConfigRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<GetExternalTicketProvisionerConfigRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExternalTicketProvisionerConfigRequest): GetExternalTicketProvisionerConfigRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExternalTicketProvisionerConfigRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.GetExternalTicketProvisionerConfigRequest
 */
export const GetExternalTicketProvisionerConfigRequest = new GetExternalTicketProvisionerConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExternalTicketProvisionerConfigResponse$Type extends MessageType<GetExternalTicketProvisionerConfigResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.GetExternalTicketProvisionerConfigResponse", [
            { no: 1, name: "config", kind: "message", T: () => ExternalTicketProvisionerConfig }
        ]);
    }
    create(value?: PartialMessage<GetExternalTicketProvisionerConfigResponse>): GetExternalTicketProvisionerConfigResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetExternalTicketProvisionerConfigResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExternalTicketProvisionerConfigResponse): GetExternalTicketProvisionerConfigResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.external_tickets.v1.ExternalTicketProvisionerConfig config */ 1:
                    message.config = ExternalTicketProvisionerConfig.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExternalTicketProvisionerConfigResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.external_tickets.v1.ExternalTicketProvisionerConfig config = 1; */
        if (message.config)
            ExternalTicketProvisionerConfig.internalBinaryWrite(message.config, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.GetExternalTicketProvisionerConfigResponse
 */
export const GetExternalTicketProvisionerConfigResponse = new GetExternalTicketProvisionerConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorExternalTicketProvisioner$Type extends MessageType<ConnectorExternalTicketProvisioner> {
    constructor() {
        super("c1.api.external_tickets.v1.ConnectorExternalTicketProvisioner", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "ticket_schemas", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketSchema },
            { no: 8, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorExternalTicketProvisioner>): ConnectorExternalTicketProvisioner {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenantId = "";
        message.appId = "";
        message.connectorId = "";
        message.ticketSchemas = [];
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorExternalTicketProvisioner>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorExternalTicketProvisioner): ConnectorExternalTicketProvisioner {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 3:
                    message.connectorId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 6:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* repeated c1.connector.v2.TicketSchema ticket_schemas */ 7:
                    message.ticketSchemas.push(TicketSchema.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string display_name */ 8:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorExternalTicketProvisioner, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 3; */
        if (message.connectorId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.connectorId);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 6; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.connector.v2.TicketSchema ticket_schemas = 7; */
        for (let i = 0; i < message.ticketSchemas.length; i++)
            TicketSchema.internalBinaryWrite(message.ticketSchemas[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 8; */
        if (message.displayName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.displayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ConnectorExternalTicketProvisioner
 */
export const ConnectorExternalTicketProvisioner = new ConnectorExternalTicketProvisioner$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalTicketProvisionerConfig$Type extends MessageType<ExternalTicketProvisionerConfig> {
    constructor() {
        super("c1.api.external_tickets.v1.ExternalTicketProvisionerConfig", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "ticket_title_template", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "ticket_body_template", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "ticket_schema", kind: "message", T: () => TicketSchema },
            { no: 11, name: "error_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "success_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "ticket_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "out_of_date", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ExternalTicketProvisionerConfig>): ExternalTicketProvisionerConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenantId = "";
        message.appId = "";
        message.connectorId = "";
        message.id = "";
        message.ticketTitleTemplate = "";
        message.ticketBodyTemplate = "";
        message.errorStatus = "";
        message.successStatus = "";
        message.displayName = "";
        message.label = "";
        message.ticketType = "";
        message.outOfDate = false;
        if (value !== undefined)
            reflectionMergePartial<ExternalTicketProvisionerConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalTicketProvisionerConfig): ExternalTicketProvisionerConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 3:
                    message.connectorId = reader.string();
                    break;
                case /* string id */ 4:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 7:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* string ticket_title_template */ 8:
                    message.ticketTitleTemplate = reader.string();
                    break;
                case /* string ticket_body_template */ 9:
                    message.ticketBodyTemplate = reader.string();
                    break;
                case /* c1.connector.v2.TicketSchema ticket_schema */ 10:
                    message.ticketSchema = TicketSchema.internalBinaryRead(reader, reader.uint32(), options, message.ticketSchema);
                    break;
                case /* string error_status */ 11:
                    message.errorStatus = reader.string();
                    break;
                case /* string success_status */ 12:
                    message.successStatus = reader.string();
                    break;
                case /* string display_name */ 13:
                    message.displayName = reader.string();
                    break;
                case /* string label */ 14:
                    message.label = reader.string();
                    break;
                case /* string ticket_type */ 15:
                    message.ticketType = reader.string();
                    break;
                case /* bool out_of_date */ 16:
                    message.outOfDate = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalTicketProvisionerConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 3; */
        if (message.connectorId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.connectorId);
        /* string id = 4; */
        if (message.id !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 7; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string ticket_title_template = 8; */
        if (message.ticketTitleTemplate !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.ticketTitleTemplate);
        /* string ticket_body_template = 9; */
        if (message.ticketBodyTemplate !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.ticketBodyTemplate);
        /* c1.connector.v2.TicketSchema ticket_schema = 10; */
        if (message.ticketSchema)
            TicketSchema.internalBinaryWrite(message.ticketSchema, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string error_status = 11; */
        if (message.errorStatus !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.errorStatus);
        /* string success_status = 12; */
        if (message.successStatus !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.successStatus);
        /* string display_name = 13; */
        if (message.displayName !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.displayName);
        /* string label = 14; */
        if (message.label !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.label);
        /* string ticket_type = 15; */
        if (message.ticketType !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.ticketType);
        /* bool out_of_date = 16; */
        if (message.outOfDate !== false)
            writer.tag(16, WireType.Varint).bool(message.outOfDate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ExternalTicketProvisionerConfig
 */
export const ExternalTicketProvisionerConfig = new ExternalTicketProvisionerConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalTicketProvisionerConfigRef$Type extends MessageType<ExternalTicketProvisionerConfigRef> {
    constructor() {
        super("c1.api.external_tickets.v1.ExternalTicketProvisionerConfigRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExternalTicketProvisionerConfigRef>): ExternalTicketProvisionerConfigRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ExternalTicketProvisionerConfigRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalTicketProvisionerConfigRef): ExternalTicketProvisionerConfigRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalTicketProvisionerConfigRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ExternalTicketProvisionerConfigRef
 */
export const ExternalTicketProvisionerConfigRef = new ExternalTicketProvisionerConfigRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalTicketRef$Type extends MessageType<ExternalTicketRef> {
    constructor() {
        super("c1.api.external_tickets.v1.ExternalTicketRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "external_ticket_provisioner_config_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExternalTicketRef>): ExternalTicketRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.externalTicketProvisionerConfigId = "";
        if (value !== undefined)
            reflectionMergePartial<ExternalTicketRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalTicketRef): ExternalTicketRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string external_ticket_provisioner_config_id */ 2:
                    message.externalTicketProvisionerConfigId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalTicketRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string external_ticket_provisioner_config_id = 2; */
        if (message.externalTicketProvisionerConfigId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.externalTicketProvisionerConfigId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ExternalTicketRef
 */
export const ExternalTicketRef = new ExternalTicketRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalTicket$Type extends MessageType<ExternalTicket> {
    constructor() {
        super("c1.api.external_tickets.v1.ExternalTicket", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "external_ticket_provisioner_config_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "external_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "external_ticket_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "external_ticket_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "state", kind: "enum", T: () => ["c1.api.external_tickets.v1.ExternalTicketState", ExternalTicketState, "EXTERNAL_TICKET_STATE_"] },
            { no: 12, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "internal_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "attempts", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "last_error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "external_ticket_status_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExternalTicket>): ExternalTicket {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenantId = "";
        message.externalTicketProvisionerConfigId = "";
        message.id = "";
        message.externalTicketId = "";
        message.externalTicketStatus = "";
        message.externalTicketUrl = "";
        message.state = 0;
        message.appId = "";
        message.connectorId = "";
        message.internalTicketId = "";
        message.attempts = 0;
        message.lastError = "";
        message.externalTicketStatusDisplayName = "";
        if (value !== undefined)
            reflectionMergePartial<ExternalTicket>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalTicket): ExternalTicket {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string external_ticket_provisioner_config_id */ 2:
                    message.externalTicketProvisionerConfigId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 6:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* string external_ticket_id */ 7:
                    message.externalTicketId = reader.string();
                    break;
                case /* string external_ticket_status */ 8:
                    message.externalTicketStatus = reader.string();
                    break;
                case /* string external_ticket_url */ 9:
                    message.externalTicketUrl = reader.string();
                    break;
                case /* c1.api.external_tickets.v1.ExternalTicketState state */ 11:
                    message.state = reader.int32();
                    break;
                case /* string app_id */ 12:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 13:
                    message.connectorId = reader.string();
                    break;
                case /* string internal_ticket_id */ 14:
                    message.internalTicketId = reader.string();
                    break;
                case /* int32 attempts */ 15:
                    message.attempts = reader.int32();
                    break;
                case /* string last_error */ 16:
                    message.lastError = reader.string();
                    break;
                case /* string external_ticket_status_display_name */ 17:
                    message.externalTicketStatusDisplayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalTicket, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string external_ticket_provisioner_config_id = 2; */
        if (message.externalTicketProvisionerConfigId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.externalTicketProvisionerConfigId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 6; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string external_ticket_id = 7; */
        if (message.externalTicketId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.externalTicketId);
        /* string external_ticket_status = 8; */
        if (message.externalTicketStatus !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.externalTicketStatus);
        /* string external_ticket_url = 9; */
        if (message.externalTicketUrl !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.externalTicketUrl);
        /* c1.api.external_tickets.v1.ExternalTicketState state = 11; */
        if (message.state !== 0)
            writer.tag(11, WireType.Varint).int32(message.state);
        /* string app_id = 12; */
        if (message.appId !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 13; */
        if (message.connectorId !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.connectorId);
        /* string internal_ticket_id = 14; */
        if (message.internalTicketId !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.internalTicketId);
        /* int32 attempts = 15; */
        if (message.attempts !== 0)
            writer.tag(15, WireType.Varint).int32(message.attempts);
        /* string last_error = 16; */
        if (message.lastError !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.lastError);
        /* string external_ticket_status_display_name = 17; */
        if (message.externalTicketStatusDisplayName !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.externalTicketStatusDisplayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.ExternalTicket
 */
export const ExternalTicket = new ExternalTicket$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExternalTicketRequest$Type extends MessageType<GetExternalTicketRequest> {
    constructor() {
        super("c1.api.external_tickets.v1.GetExternalTicketRequest", [
            { no: 1, name: "provisioner_config_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "external_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetExternalTicketRequest>): GetExternalTicketRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.provisionerConfigId = "";
        message.externalTicketId = "";
        if (value !== undefined)
            reflectionMergePartial<GetExternalTicketRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExternalTicketRequest): GetExternalTicketRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string provisioner_config_id */ 1:
                    message.provisionerConfigId = reader.string();
                    break;
                case /* string external_ticket_id */ 4:
                    message.externalTicketId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExternalTicketRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string provisioner_config_id = 1; */
        if (message.provisionerConfigId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.provisionerConfigId);
        /* string external_ticket_id = 4; */
        if (message.externalTicketId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.externalTicketId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.GetExternalTicketRequest
 */
export const GetExternalTicketRequest = new GetExternalTicketRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExternalTicketResponse$Type extends MessageType<GetExternalTicketResponse> {
    constructor() {
        super("c1.api.external_tickets.v1.GetExternalTicketResponse", [
            { no: 1, name: "external_ticket", kind: "message", T: () => ExternalTicket }
        ]);
    }
    create(value?: PartialMessage<GetExternalTicketResponse>): GetExternalTicketResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetExternalTicketResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExternalTicketResponse): GetExternalTicketResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.external_tickets.v1.ExternalTicket external_ticket */ 1:
                    message.externalTicket = ExternalTicket.internalBinaryRead(reader, reader.uint32(), options, message.externalTicket);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExternalTicketResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.external_tickets.v1.ExternalTicket external_ticket = 1; */
        if (message.externalTicket)
            ExternalTicket.internalBinaryWrite(message.externalTicket, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_tickets.v1.GetExternalTicketResponse
 */
export const GetExternalTicketResponse = new GetExternalTicketResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.external_tickets.v1.ExternalTickets
 */
export const ExternalTickets = new ServiceType("c1.api.external_tickets.v1.ExternalTickets", [
    { name: "ListConnectorExternalTicketProvisioner", options: { "authz.method": { role: "VIEWER" } }, I: ListConnectorExternalTicketProvisionerRequest, O: ListConnectorExternalTicketProvisionerResponse },
    { name: "CreateExternalTicketProvisionerConfig", options: { "authz.method": { role: "EDITOR" } }, I: CreateExternalTicketProvisionerConfigRequest, O: CreateExternalTicketProvisionerConfigResponse },
    { name: "ListExternalTicketProvisionerConfig", options: { "authz.method": { role: "VIEWER" } }, I: ListExternalTicketProvisionerConfigRequest, O: ListExternalTicketProvisionerConfigResponse },
    { name: "GetExternalTicketProvisionerConfig", options: { "authz.method": { role: "VIEWER" } }, I: GetExternalTicketProvisionerConfigRequest, O: GetExternalTicketProvisionerConfigResponse },
    { name: "GetConnectorExternalTicketProvisioner", options: { "authz.method": { role: "VIEWER" } }, I: GetConnectorExternalTicketProvisionerRequest, O: GetConnectorExternalTicketProvisionerResponse },
    { name: "UpdateExternalTicketProvisionerConfig", options: { "authz.method": { role: "EDITOR" } }, I: UpdateExternalTicketProvisionerConfigRequest, O: UpdateExternalTicketProvisionerConfigResponse },
    { name: "DeleteExternalTicketProvisionerConfig", options: { "authz.method": { role: "EDITOR" } }, I: DeleteExternalTicketProvisionerConfigRequest, O: DeleteExternalTicketProvisionerConfigResponse },
    { name: "GetExternalTicket", options: { "authz.method": { role: "VIEWER" } }, I: GetExternalTicketRequest, O: GetExternalTicketResponse },
    { name: "ProcessExternalTicketForBulkAction", options: { "authz.method": { role: "EDITOR" } }, I: ProcessExternalTicketForBulkActionRequest, O: ProcessExternalTicketForBulkActionResponse }
]);
